export default __webpack_public_path__ + "static/media/bdswissReal_downloadMT5.743cd7ab.png";